export enum Module {
  operator = 'operator',
  kms = 'kms',
  vms = 'vms',
  admin = 'admin',
}

export type ModuleValues = `${Module}`;
